module.exports = __webpack_public_path__ + "static/media/LogoAruacoPlus.80ccfb39.png";